import Typography from '@blueshift-ui/theme/src/components/typography';
import { Box } from '@mui/material';
import BulletList from '../shared/bullet-list';
import ContinueButton from '../shared/continue-button';

function CartMissing() {
  return (
    <>
      <Typography
        alignSelf="flex-start"
        fontSize="2rem"
        fontWeight="bold"
        lineHeight="2.5rem"
        variant="h3"
      >
        Sorry,
      </Typography>
      <Typography fontSize="2rem" fontWeight="bold" lineHeight="2.5rem" mb="0.5rem" variant="h3">
        {"we're unable to complete checkout."}
      </Typography>
      <Typography mb="1.5rem">
        There was a problem with the item you attempted to purchase.
      </Typography>
      <Box alignSelf="flex-start">Possible issues:</Box>
      <BulletList sx={{ marginBottom: '1rem' }}>
        <li>Nothing was in your cart</li>
        <li>The plan is no longer available</li>
        <li>The plan has already been purchased</li>
      </BulletList>
      <Typography marginBottom="1.5rem">
        Please return to the home page and try checking out again.
      </Typography>
      <ContinueButton href="/" loading={false}>
        Return to home
      </ContinueButton>
    </>
  );
}

export default CartMissing;
